import {from, forkJoin} from 'rxjs';
import {ShapeCommand} from '../commands.template';
import {urlToBlob} from '../../diagram-render/helpers/image.util';
import {mergeMap} from 'rxjs/operators';

export interface Creds {
  signedUrl: string;
  key: string;
  fileStatus: string;
}

export class ImageCreateCommand extends ShapeCommand {
  protected services: any;

  constructor(data) {
    super(data);
  }

  public execute(): Promise<any /** mxCell **/> {
    super.execute();
    const prepared = this.prepImage(this.object.fileData);
    const graph = this.services.editorRegistrySvc.getGraph();
    const imageVertex = this.services.shapeSpawnerSvc.createImage(this.object, prepared);

    if (this.object.mxKey) {
      graph.addCell(imageVertex, this.services.graphHelperSvc.imageParent());
      this.executeJson(this.object);

      return imageVertex;
    }

    return from(this.services.imgSvc.getImageShapeUploadUrl(this.object.fileType))
      .pipe(
        mergeMap((credentials: Creds) => {
          this.object.uuid = credentials.key;

          return forkJoin([
            this.services.imgSvc.uploadImage(
              credentials.signedUrl,
              urlToBlob(this.object.fileData)
            ),
            this.services.q9StaticFileUploadSvc.trackFileStatus(credentials.fileStatus, {
              autoNotification: true
            })
          ]);
        })
      )
      .toPromise()
      .then(() => {
        graph.addCell(imageVertex, this.services.graphHelperSvc.imageParent());
        this.services.spinnerSvc.hide();
        this.object.mxKey = Number(imageVertex.id);
        this.executeJson(this.object);

        return imageVertex;
      })
      .catch(() => this.services.spinnerSvc.hide());
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      createImage: {
        uuid: data.uuid,
        mxKey: Number(data.mxKey),
        position: {
          x: Number(data.position.x),
          y: Number(data.position.y),
          w: Number(data.position.w),
          h: Number(data.position.h),
          r: 0
        },
        copyImage: false,
        link: data.link
      }
    });
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();

    const imageVertex = this.services.graphHelperSvc
      .allImages()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    graph.removeCells([imageVertex], false);

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteImage: {mxKey: Number(data.mxKey)}
    });
  }

  private prepImage(fileData) {
    const semi = fileData.indexOf(';');

    if (semi > 0) {
      fileData = fileData.substring(0, semi) + fileData.substring(fileData.indexOf(',', semi + 1));
    }

    return fileData;
  }
}
